import PageNavigation from '../page-navigation/page-navigation';

export default PageNavigation;